import { SUBSCRIPTION_PLAN, type SubscriptionPlan } from 'src/data/subscription';
import { trackMarketoEvent as mutationTrackMarketoEvent } from 'src/graphql/event';
import { captureMessage } from 'src/lib/sentry';

export const MARKETO_EVENT = {
  clickedUpgradeButton: 'clicked_upgrade_button',
};
type MarketoEvent = (typeof MARKETO_EVENT)[keyof typeof MARKETO_EVENT];

export const MARKETO_SUBSCRIPTION_ACTION = {
  buyNow: 'buy_now',
  bookDemo: 'book_a_demo',
  requestDemo: 'request_a_demo',
};

const MARKETO_SUBSCRIPTION_PLAN_VALUE = {
  basic: 'basic',
  starter: 'starter',
  dataDriven: 'data_driven',
  businessSelfServe: 'business_self_serve',
  business: 'business',
  enterprise: 'enterprise',

  // Not used anymore values
  /*
  acquisition: 'acquisition',
  conversion: 'conversion',
  engagement: 'engagement',
  */
};
type MarketoSubscriptionPlan =
  (typeof MARKETO_SUBSCRIPTION_PLAN_VALUE)[keyof typeof MARKETO_SUBSCRIPTION_PLAN_VALUE];

export const trackMarketoEvent = (
  eventName: MarketoEvent,
  primaryValue: string,
  attributes: object
) => {
  mutationTrackMarketoEvent(eventName, primaryValue, attributes).catch((error) => {
    captureMessage('Error tracking Marketo event', {
      level: 'warning',
      extra: {
        error: error.toString(),
        source: 'lib/events/marketo -> trackMarketoEvent',
        eventName,
        primaryValue,
        attributes,
      },
    });
  });
};

export const convertSubscriptionPlanForMarketo = (
  plan: SubscriptionPlan
): MarketoSubscriptionPlan | SubscriptionPlan => {
  switch (plan) {
    case SUBSCRIPTION_PLAN.basic:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.basic;

    case SUBSCRIPTION_PLAN.starter:
    case SUBSCRIPTION_PLAN.starterLegacy:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.starter;

    case SUBSCRIPTION_PLAN.dataDriven:
    case SUBSCRIPTION_PLAN.ddTeamsLegacy:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.dataDriven;

    case SUBSCRIPTION_PLAN.businessSelfServeLegacy:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.businessSelfServe;

    case SUBSCRIPTION_PLAN.business:
    case SUBSCRIPTION_PLAN.businessPlus:
    case SUBSCRIPTION_PLAN.businessMax:
    case SUBSCRIPTION_PLAN.proPublisherLegacy:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.business;

    case SUBSCRIPTION_PLAN.performance:
    case SUBSCRIPTION_PLAN.performancePlus:
    case SUBSCRIPTION_PLAN.performanceMax:
    case SUBSCRIPTION_PLAN.enterpriseLegacy:
      return MARKETO_SUBSCRIPTION_PLAN_VALUE.enterprise;

    default:
      return plan;
  }
};
